
import styles from "./Style.module.css";

const Loader = ({ fullPage = false }) => {
	return (
		<div className={fullPage ? styles.fullPageLoader : styles.inlineLoader}>
			<div className={styles.circleBorder}>
				<div className={styles.circleCore}></div>
			</div>
		</div>
	);
};

export default Loader;
